module.exports = __webpack_public_path__ + "static/content-f-91d6a620aee32e0233daf8a81333f464.png";